import React, { useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import Button from "react-bootstrap/Button";
import "../BusinessProfile/style.css";
import PhoneInput from "react-phone-input-2";
import { useDispatch, useSelector } from "react-redux";
import { Card, Col, Form, Row, Stack } from "react-bootstrap";
import { fetchBusinessProfileData } from "../../redux/slice/BusinessProfileSlice";
import Loader from "../../components/Common/Loader/PrimaryLoader";
import { fetchsuperadminapproverdata } from "../../redux/slice/CreateLocationSlice";
import {
  UpdateBusinessProfile,
  fetchUserProfileData,
} from "../../redux/slice/UserProfileSlice";
import { Link, NavLink } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ValidationSchema from "../../components/Common/ValidationSchema";
import { StatusCode } from "../../services/helper";
import ButtonLoader from "../../components/Common/ButtonLoader";
import Create from "../../Assets/icons/create.png";
// import noimage from "../../Assets/no-img/no-image-icon.png";
import LocationPopup from "./LocationPopup/LocationPopup";
import { toast } from "react-toastify";
import LocationSlider from "../../components/LocationSlider";
import noimage from "../../Assets/Profile/business-icon.svg";
import { authUser } from "../../redux/slice/AuthSlice";

const BusinessProfile = () => {
  const { status, BusinessProfileData } = useSelector(
    (state) => state.BUSINESSPROFILE
  );
  const { BusinessprofileForm, formloadstatus } = useSelector(
    (state) => state.BUSINESSPROFILEFORM
  );

  const dispatch = useDispatch();
  const [companyLogoPreview, setCompanyLogoPreview] = useState(null);
  const [whiteCompanyLogoPreview, setWhiteCompanyLogoPreview] = useState(null);
  const whiteLogoRef = useRef();
  const secWhiteLogoRef = useRef();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState({});
  const [selectedSuperAdmin, setSelectedSuperAdmin] = useState(null); // State to store selected super admin

  const userData = BusinessProfileData?.locations || [];
  const company = BusinessProfileData?.company || [];
  const superAdmins = BusinessprofileForm?.superadmins || [];

  const companyEmail = company.distributor_email || "";
  const compNumber = company.distributor_email || "";
  const initialValues = {
    company_name: "",
    company_logo: null,
    company_white_logo: null,
    country_code: "",
    contact_number: "",
    email: "",
    assigned_role: "",
    superadmin_id: "",
    superadmin_email: "",
  };

  const {
    values,
    errors,
    handleBlur,
    handleChange,
    touched,
    setValues,
    handleSubmit,
  } = useFormik({
    initialValues: initialValues,
    validationSchema: ValidationSchema.updateBusinessProfileUser,
    onSubmit: async (values) => {
      const payload = {
        company_name: values.company_name,
        country_code: values.country_code,
        contact_number: values.contact_number,
        // email: values.email,
        // assigned_role: values.assigned_role,
        company_logo: values.company_logo,
        company_white_logo: values.company_white_logo,
        // superadmin_id: values.superadmin_id,
        // superadmin_email: values.superadmin_email,
      };
      const res = await dispatch(UpdateBusinessProfile(payload));
      if (res?.payload?.status === 200) {
        dispatch(fetchUserProfileData());
        dispatch(authUser());
      }
    },
  });

  useEffect(() => {
    setValues({
      ...values,
      company_name: BusinessprofileForm?.business_profile?.company_name || "",
      company_logo: BusinessprofileForm?.business_profile?.company_logo || "",
      company_white_logo:
        BusinessprofileForm?.business_profile?.company_white_logo || "",
      country_code: BusinessprofileForm?.business_profile?.country_code || "",
      contact_number:
        BusinessprofileForm?.business_profile?.contact_number || "",
      email: BusinessprofileForm?.business_profile?.email || "",
      assigned_role: BusinessprofileForm?.business_profile?.assigned_role || "",
      superadmin_id: BusinessprofileForm?.business_profile?.superadmin_id || "",
      superadmin_email:
        BusinessprofileForm?.business_profile?.superadmin_email || "",
    });
  }, [BusinessprofileForm]);

  const handleLogoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.type.startsWith("image/")) {
        if (e.target.name === "company_logo") {
          setCompanyLogoPreview(URL.createObjectURL(file));
          setValues({ ...values, company_logo: file });
        } else {
          setWhiteCompanyLogoPreview(URL.createObjectURL(file));
          setValues({ ...values, company_white_logo: file });
        }
      } else {
        toast.error("Please select a valid image file");
      }
    }
  };

  useEffect(() => {
    dispatch(fetchBusinessProfileData());
    dispatch(fetchUserProfileData());
    dispatch(fetchsuperadminapproverdata());
  }, [dispatch]);

  const handleSuperAdminSelect = (superadminId) => {
    const selectedSuperAdmin = superAdmins.find(
      (admin) => admin._id === superadminId
    );
    if (selectedSuperAdmin) {
      setSelectedSuperAdmin(selectedSuperAdmin);
      setValues({
        ...values,
        email: selectedSuperAdmin.email,
        superadmin_id: selectedSuperAdmin._id,
        superadmin_email: selectedSuperAdmin.email,
      });
    }
  };

  const handleCardClick = (locationData) => {
    setSelectedLocation({
      ...locationData,
      country_code: locationData?.telephone.split(" ")[0],
      telephone: locationData?.telephone.split(" ")[1],
    }); // Set selected location data
    setIsModalOpen(true); // Open the modal
  };

  if (status === "loading" && !isModalOpen) {
    return <Loader />;
  }

  const name = `${BusinessprofileForm?.business_profile?.first_name ?? ""} ${
    BusinessprofileForm?.business_profile?.last_name ?? ""
  }`;

  const handleCloseLocationPopup = () => {
    setIsModalOpen(false);
    setSelectedLocation({});
  };

  return (
    <Stack>
      <Row className="h-100 row-gap-3">
        {isModalOpen && (
          <LocationPopup
            isOpen={isModalOpen}
            onClose={handleCloseLocationPopup}
            selectedLocation={selectedLocation}
          />
        )}
        <Col xs={12} md={6} className="h-100">
          <Form
            onSubmit={handleSubmit}
            className="bg-white h-100 d-flex flex-column popup-layout"
            style={{ borderRadius: "16px" }}
          >
            <Stack className=" h-100">
              <div
                className="position-sticky bg-white header-section"
                style={{ zIndex: 1 }}
              >
                <h4 className="text-center fw-bold m-0">Business Profile</h4>
                <hr />
              </div>
              <div className="pb-3">
                <div className="row row-gap-3 g-0 gx-xl-3">
                  <div className="col-12 col-xl-6">
                    <div className="companylogo text-center">
                      <Form.Group controlId="formBasiccompany_logo">
                        <Form.Control
                          ref={whiteLogoRef}
                          type="file"
                          accept="image/*"
                          name="company_logo"
                          className="d-none"
                          onChange={handleLogoChange}
                          onBlur={handleBlur}
                        />
                      </Form.Group>
                      <div className="p-2" style={{ height: "200px" }}>
                        <img
                          src={
                            values.company_logo === ""
                              ? noimage
                              : companyLogoPreview
                              ? companyLogoPreview
                              : values.company_logo
                          }
                          alt={
                            values.company_logo === ""
                              ? "noimage"
                              : "company logo"
                          }
                          style={{ height: "100%", width: "100%" }}
                        />
                      </div>
                    </div>
                    <div className="text-center pt-2">
                      <button
                        className="border-0 background-transparent"
                        type="button"
                        onClick={() => whiteLogoRef.current.click()}
                        style={{ fontSize: "14px" }}
                      >
                        Edit Normal Logo
                      </button>
                    </div>
                  </div>
                  <div className="col-12 col-xl-6">
                    <div className="companylogo text-center">
                      <Form.Group controlId="formBasiccompany_logo">
                        <Form.Control
                          ref={secWhiteLogoRef}
                          type="file"
                          accept="image/*"
                          name="company_white_logo"
                          className="d-none"
                          onChange={handleLogoChange}
                          onBlur={handleBlur}
                        />
                      </Form.Group>
                      <div className="p-2" style={{ height: "200px" }}>
                        <img
                          src={
                            values.company_white_logo === ""
                              ? noimage
                              : whiteCompanyLogoPreview
                              ? whiteCompanyLogoPreview
                              : values.company_white_logo
                          }
                          alt={
                            values.company_white_logo === ""
                              ? "noimage"
                              : "company logo"
                          }
                          style={{ height: "100%", width: "100%" }}
                        />
                      </div>
                    </div>
                    <div className="text-center pt-2">
                      <button
                        className="border-0 background-transparent"
                        type="button"
                        onClick={() => secWhiteLogoRef.current.click()}
                        style={{ fontSize: "14px" }}
                      >
                        Edit White Logo
                      </button>
                    </div>
                  </div>
                </div>
                <hr />
                <div className="row row-gap-3 g-0">
                  <Form.Group
                    className="col-12"
                    controlId="formBasicBusinessName"
                  >
                    <Form.Control
                      type="text"
                      name="company_name"
                      value={values.company_name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      placeholder="Business Name"
                    />
                    {errors.company_name && touched.company_name && (
                      <p className="text-danger mt-1 mb-0">
                        {errors.company_name}
                      </p>
                    )}
                  </Form.Group>
                  <Form.Group
                    className="col-12"
                    controlId="formBasicBusinessName"
                  >
                    <div className="phn_input">
                      <div className="phone-input">
                        <PhoneInput
                          name="country_code"
                          country={""}
                          disableTyping={true}
                          inputProps={{
                            readOnly: true,
                          }}
                          value={values.country_code}
                          onChange={(value) =>
                            handleChange({
                              target: {
                                name: "country_code",
                                value: `+${value}`,
                              },
                            })
                          }
                        />
                      </div>
                      <Form.Control
                        onKeyPress={(e) => {
                          if (
                            e.key === "e" ||
                            e.key === "E" ||
                            isNaN(Number(e.key))
                          ) {
                            e.preventDefault();
                          }
                        }}
                        onKeyDown={(e) => {
                          if (e.key === " ") {
                            e.preventDefault();
                          }
                        }}
                        name="contact_number"
                        type="text"
                        pattern="[0-9]*"
                        value={values.contact_number}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder="Number"
                      />
                    </div>
                    {((errors.country_code && touched.country_code) ||
                      (errors.contact_number && touched.contact_number)) && (
                      <Stack direction="horizontal" gap={2}>
                        {errors.country_code && touched.country_code && (
                          <p className="text-danger mt-1 mb-0">
                            {errors.country_code}
                          </p>
                        )}
                        {errors.contact_number && touched.contact_number && (
                          <p className="text-danger mt-1 mb-0">
                            {errors.contact_number}
                          </p>
                        )}
                      </Stack>
                    )}
                  </Form.Group>
                  <Form.Group
                    className="col-12"
                    controlId="formBasicBusinessEmail"
                  >
                    <Form.Control
                      type="email"
                      name="email"
                      value={values.email}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      placeholder="Business Email"
                      disabled
                    />
                    {errors.email && touched.email && (
                      <p className="text-danger mt-1 mb-0">{errors.email}</p>
                    )}
                  </Form.Group>
                  <hr className="m-0" />
                  <Stack className="col-12 row-gap-3">
                    <p className="m-0 fw-bold">Assigned Super Admin</p>
                    <Form.Group controlId="formBasicAssignApprover">
                      <Form.Control
                        name="superadmin_id"
                        type="text"
                        value={name}
                        disabled
                      />
                    </Form.Group>
                    {/* <Form.Group
                  className="mb-3"
                  controlId="formBasicAssignApprover"
                >
                  <Form.Select
                    aria-label="Default select example"
                    name="superadmin_id"
                    onChange={(e) => handleSuperAdminSelect(e.target.value)}
                    value={values.superadmin_id}
                    onBlur={handleBlur}
                    disabled
                  >
                    <option value="">Select Super Admin</option>
                    {superAdmins.map((admin) => (
                      <option key={admin._id} value={admin._id}>
                        {`${admin.first_name} ${admin.last_name}`}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
                {errors.superadmin_id && touched.superadmin_id && (
                  <p className="text-danger mt-1 mb-0">
                    {errors.superadmin_id}
                  </p>
                )} */}
                  </Stack>
                </div>
              </div>
            </Stack>
            <div className="footer-section position-sticky bg-white">
              <hr className="mt-0" />
              <div className="d-flex justify-content-end align-items-center gap-3 flex-wrap flex-wrap-reverse">
                <NavLink to="/users" className="flex-grow-1 flex-xxl-grow-0">
                  <Button variant="dark w-100">Cancel</Button>
                </NavLink>
                <Button
                  variant="primary"
                  type="submit"
                  className="p-auto px-xxl-5 flex-grow-1 flex-xxl-grow-0"
                >
                  {formloadstatus === StatusCode.LOADING ? (
                    <ButtonLoader />
                  ) : (
                    "Save Changes"
                  )}
                </Button>
              </div>
            </div>
          </Form>
        </Col>
        <Col xs={12} md={6} className="h-100">
          <Stack className="h-100 row-gap-3">
            <div className="kits_row px-0">
              <div className="top-btns">
                <Card style={{ borderRadius: 16, border: "none" }}>
                  <Link
                    to="/createlocation"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    <Button
                      variant="primary"
                      className="icon-button column-gap-2"
                    >
                      <img src={Create} alt="User Icon" />
                      <h3 className="button-text m-0">Create Location</h3>
                    </Button>
                  </Link>
                </Card>
              </div>
            </div>
            <Form
              onSubmit={handleSubmit}
              className="bg-white h-100 d-flex flex-column popup-layout"
              style={{ borderRadius: "16px" }}
            >
              <div
                className="position-sticky bg-white header-section"
                style={{ zIndex: 1 }}
              >
                <h4 className="fw-bold m-0">Company Locations</h4>
                <hr />
              </div>
              <div className="flex-grow-1 position-relative">
                <div className="position-absolute w-100 h-100">
                  <Stack className="overflow-y-auto h-100">
                    {userData.map((location, index) => (
                      <div key={index}>
                        <Stack
                          direction="horizontal"
                          key={index}
                          className="p-2 cursor justify-content-between gap-3 hover-primary"
                          onClick={() => handleCardClick(location)}
                        >
                          <p className="m-0">{location.location_name}</p>
                          <p className="m-0">{location.country}</p>
                        </Stack>
                        <hr className="my-2" />
                      </div>
                    ))}
                  </Stack>
                </div>
              </div>
            </Form>
          </Stack>
        </Col>
      </Row>
    </Stack>
  );
};

export default BusinessProfile;
